var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-1"},[_c('feather-icon',{staticClass:"text-warning",attrs:{"icon":"InfoIcon"}}),_c('span',{staticClass:"tw-mx-1 tw-text-body"},[_vm._v(" "+_vm._s(_vm.$t('full-edit-1'))+" "),_c('router-link',{attrs:{"to":_vm.resourceLink}},[_vm._v(" "+_vm._s(_vm.$t('full-edit-2'))+" ")]),_vm._v(" "+_vm._s(_vm.$t('full-edit-3'))+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }